import React from "react";
import styled from "styled-components";
import MUILink from "@mui/material/Link";

import { Grid } from "../../UI/Grid";
import { Table } from "../../UI/Table";
import { Button } from "../../UI/Button";
import { TableHead } from "../../UI/TableHead";
import { TableRow } from "../../UI/TableRow";
import { TableCell } from "../../UI/TableCell";
import { Typography } from "../../UI/Typography";
import { StyledHeaderWrapper } from "../../layout/MainLayout";
import { useAdminUsers } from "./useAdminUsers";

const Link = styled(MUILink)`
  cursor: pointer;
  display: inline-block;
  color: #007bff !important;
`;

const renderUser = ({ name, email }: { name: string, email: string }) => (
  <TableRow>
    <TableCell>
      <Typography variant="body2" fontWeight={500}>
        {name}
      </Typography>
    </TableCell>
    <TableCell>
      <Typography variant="body2" fontWeight={500}>
        {email}
      </Typography>
    </TableCell>
  </TableRow>
);

const EmptyRow = renderUser({ name: '-', email: '-' });

export const AdministratorsTree: React.FC = () => {
  const { data, fetch, isFetched, isLoading } = useAdminUsers();

  return (
    <>
      <StyledHeaderWrapper
        item
        container
        alignItems="center"
        px={4}
        mb={4}
        mt={4}
      >
        <Grid item xs>
          <Typography
            variant="h5"
            sx={{ fontWeight: "500 !important" }}
          >
            Administrators
          </Typography>
          <Typography
            variant="subtitle2"
            sx={{ fontWeight: "400 !important" }}
          >
            {"Administrators listed below have access to this network. Please contact "}
            <Link target="_blank" href="https://www.roomsync.com/help/contact-us">
              RoomSync support
            </Link>
            {" if access needs to be removed or updated for any administrators."}
          </Typography>
        </Grid>
      </StyledHeaderWrapper>
      {
        isFetched
          ? (
            <Table>
              <TableHead secondary>
                <TableRow>
                  <TableCell>Name</TableCell>
                  <TableCell>Email</TableCell>
                </TableRow>
              </TableHead>
              {data.length ? data.map(renderUser) : EmptyRow}
            </Table>
          ) : (
            <Button
              appearance="primary"
              onClick={fetch}
              isLoading={isLoading}
              isDisabled={isLoading}
            >
              Load Admin List
            </Button>
          )
      }
    </>
  );
};
